import styled from 'styled-components'
import { device } from 'components/draw/constants'

function PanelWithTitle({
  title,
  children,
  containerStyle,
  titleStyle,
  contentStyle,
}: {
  title: string
  children: React.ReactNode

  containerStyle?: React.CSSProperties
  titleStyle?: React.CSSProperties
  contentStyle?: React.CSSProperties
}) {
  return (
    <PanelContainer style={containerStyle}>
      <PanelTitle style={titleStyle}>{title}</PanelTitle>
      <PanelContent style={contentStyle}>{children}</PanelContent>
    </PanelContainer>
  )
}

export const PanelContainer = styled.div`
  position: relative;

  background-color: #4a4b51;
  border-radius: 24px;

  display: flex;
  flex-direction: column;

  padding-bottom: 8px;

  width: calc(100% - 64px);
  max-width: 1312px;

  @media ${device.laptopMax} {
    width: calc(100% - 40px);
  }
`

export const PanelTitle = styled.div`
  color: white;
  font-weight: 500;
  font-size: 18px;
  padding: 16px 32px;
`
export const PanelContent = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
  width: calc(100% - 16px);
  align-self: center;
  border-radius: 24px;

  overflow: hidden;

  @media ${device.laptopMax} {
    flex-direction: column;
  }
`

export default PanelWithTitle
